import React, { useRef } from 'react';
import _path from 'ramda/src/path';
import PropTypes from 'prop-types';

import { withMessage } from '../Common/Message';
import resx from '../../utilities/resx';
import { RESX_LISTINGS, RESX_GLOBAL } from '../../Constants';
import ListingService from '../../API/ListingService';
import Listings from '../../API/Listings';
import ListingItem from './ListingItem';
import NoResults from '../Common/NoResults';
import Spinner from '../Common/Spinner';
import GeneralUtility from '../../utilities/generalUtility';
import { PagingContext } from '../Common/Paging/PagingContext';
import Pages from '../Common/Paging/pages';
import ItemRange from '../Common/Paging/ItemRange';

const listingsPerPage = 10;

class ListingsContainer extends React.Component {
    static contextType = PagingContext;
    containerRef = React.createRef();

    constructor() {
        super();
        this.state = {
            listings: [],
            isLoadingComponent: false,
            noListingsFound: false
        };
    }

    componentDidMount = () => {
        this.browseUserListing(this.context.paging.currentPage);
    };

    browseUserListing = page => {
        const params = {
            ListingImageSize: 2,
            page: page,
            take: listingsPerPage,
            ShowPrivateViewForOwner: false,
            ListingOwnerWebsiteId: window.targetUserWebsiteId
        };

        this.setState({ isLoadingComponent: true });

        Listings.userlistings(params)
            .then(response => {
                const listingsData = _path(['data', 'Listings'], response);

                if (listingsData) {
                    if (listingsData.length === 0) {
                        this.setState({ noListingsFound: true });
                    } else {
                        listingsData.sort((a, b) => a.IsSold - b.IsSold);
                        this.setState({ listings: listingsData });
                        const { setPaging } = this.context;
                        setPaging({
                            currentPage: page,
                            totalItems: _path(['data', 'TotalCount'], response),
                            itemsPerPage: listingsPerPage
                        });
                        if (this.containerRef.current) {
                            window.scrollTo({
                                top: this.containerRef.current.offsetTop,
                                behavior: 'smooth'
                            });
                        }
                    }
                } else {
                    throw new Error(resx(RESX_GLOBAL, 'GENERIC_WEBSERVICE_ERROR_MESSAGE'));
                }
            })
            .catch(error => {
                let errorMessage;

                if (error.response && error.response.status) {
                    errorMessage = 'Error retrieving listings';
                } else {
                    errorMessage = error.message;
                }

                this.props.message.addMessage({ message: errorMessage, type: 'error' });
                GeneralUtility.logWebRequestFailure(error, `fetch featured user listings`);
            })
            .then(() => {
                this.setState({ isLoadingComponent: false });
            });
    };

    render() {
        return (
            <div ref={this.containerRef}>
                <ItemRange isLoading={this.state.isLoadingComponent} loadingSize="xs" />
                {this.state.noListingsFound ? (
                    <NoResults
                        message={`${window.targetFirstName} ${window.targetLastName} ${resx(
                            RESX_LISTINGS,
                            'LISTINGS_PAGE_NO_DATA'
                        )}`}
                        src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/b84d183e-0261-404f-a18c-84c66586f922.png?width=250"
                        href={`/${window.targetDomain}`}
                        hrefText={resx(RESX_LISTINGS, 'VIEW_PROFILE_INSTEAD_TEXT')}
                    />
                ) : (
                    this.state.listings.map(listing => <ListingItem key={listing.ListingId} listing={listing} />)
                )}
                <Pages onPageChange={newPage => this.browseUserListing(newPage)} />
                <ItemRange isLoading={this.state.isLoadingComponent} loadingSize="xxl" />
            </div>
        );
    }
}

ListingsContainer.propTypes = {
    message: PropTypes.object
};

export default withMessage(ListingsContainer);
